import store from '../store';

const clientRoutes = [
	{ 
		path: '/admin/clients',
		name: 'clients.index', 
		component: require('../pages/clients/ClientsIndex.vue').default
	},	

	{ 
		path: '/admin/clients/create',
		name: 'clients.create', 
		component: require('../pages/clients/ClientItemCreate.vue').default,
		beforeEnter: (to, from, next) => {
			if (!store.state.perms.can_create_client) {
				next('/error')
			}
			else {
				next()
			}
		}
	},

	{ 
		path: '/admin/clients/:id',
		name: 'clients.show', 
		component: require('../pages/clients/ClientItem.vue').default
	},	

	{ 
		path: '/admin/clients/:id/edit',
		name: 'clients.edit', 
		component: require('../pages/clients/ClientItemEdit.vue').default,

		async beforeEnter(to, from, next) {
			try {
				var perms = await store.state.perms;
				
				if (perms.can_edit_client) {
					next();
				}
				else {
					next('/error');
				}
			} catch (e) {
				next('/error');
			}
		}
	},	

];

export default clientRoutes;